import { render, staticRenderFns } from "./DealRating.vue?vue&type=template&id=1abf86dc&scoped=true&"
import script from "./DealRating.vue?vue&type=script&lang=js&"
export * from "./DealRating.vue?vue&type=script&lang=js&"
import style0 from "./DealRating.vue?vue&type=style&index=0&id=1abf86dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abf86dc",
  null
  
)

export default component.exports